<template>
  <div style="margin-top: 100px; width: 100%;" class="c-text-both">

    <div class="c-text-between   c-flex-wrap" style="width: 80%;">
      <div class="c-text-column contact-width c-text-align-start c-mb-40" style="    font-size: 18px">
        <div class="c-mb-10">
          <strong>
            <router-link to="/contact">联系我们</router-link>
          </strong>
        </div>
        <span class="c-mb-10">电子邮件: <span class="linkTag"> china@franka.de </span> </span>
        <!-- <p>地址: Frei-Otto-Straße 20, 80797 Munich</p> -->
        <!-- <p>传真: +49 89 2006069 21</p> -->
        <p class="c-mb-10">电话: 4008686996</p>
        <img src="@/assets/images/focus/dcf3e7df86e4614d1fbc7f53a5ade7f4.jpg" alt="QR code" class="qr-image"
          style="width: 80px;" />
        <p class="c-mb-5">官网公众号
        </p>
        <p>欢迎微信后台留言咨询</p>
        <!-- <p class="c-mb-20">工作时间: 周一至周五 8:30 - 17:00</p>
        <strong class="c-mt-20">销售</strong>
        <p>电子邮件:  <span class="linkTag"> sales@franka.de  </span></p>
        <strong class="c-mt-20">市场营销 / 媒体</strong>
        <p>电子邮件: <span class="linkTag"> marketing@franka.de  </span></p>
        <p>电子邮件: <span class="linkTag">press@franka.de</span></p>
        <strong class="c-mt-20">支持</strong>
        <p>电子邮件: <span class="linkTag">support@franka.de</span></p>
        <strong class="c-mt-20">研究</strong>
        <p>电子邮件: <span class="linkTag">research@franka.de</span></p>
        <strong class="c-mt-20">当地代表</strong>
        <strong class="c-mt-20">王天艺</strong>
        <p>电子邮件: <span class="linkTag"> tianyi.wang@agile-robots.com </span></p>
        <strong class="c-mt-20">印度:</strong>
        <strong class="c-mt-20">Trishit Thakur</strong>
        <p>电子邮件: <span class="linkTag"> trishit.thakur@agilerobots.com </span></p> -->

        <!-- <form method="POST">
          <label for="name">Name:</label>
          <input type="text" id="name" name="name" required>

          <label for="email">Email:</label>
          <input type="email" id="email" name="email" required>

          <button type="submit">Submit</button>
        </form> --> 

      </div>
      <div class="contact-width">
        <div class="form-container">
          <!-- action="https://formspree.io/f/xyzeyglo" -->
          <form @submit.prevent="submitForm"  action="https://formspree.io/f/mwplkbrv" method="POST" ref="form">
            <div class="c-text-between">
              <div class="form-group c-mr-10 c-flex-1">
                <label for="name">姓名*</label>
                <input type="text" v-model="name" name="name" required />
              </div>
            </div>
            
            <div class="form-group">
              <label for="company">公司/院校名称*</label>
              <input type="text" v-model="company" name="company" required />
            </div>
            <div class="form-group">
              <label for="job">院系名称</label>
              <input type="text" v-model="job" name="job" />
            </div> 
            <div class="form-group">
              <label for="phone">联系方式*</label>
              <input type="tel" v-model="phone" name="phone" required/>
            </div>
            
            <div class="form-group">
              <label for="email">电子邮件</label>
              <input type="email" v-model="email" name="email" />
            </div>  
            <!-- <div class="form-group">
              <label for="country">国家*</label>
              <input type="text" v-model="country" name="country" required />
            </div> -->
            <div class="form-group">
              <label for="message">请填写您的需求</label>
              <textarea class="textareaInput" v-model="message" name="message" rows="4" cols="50"></textarea>
            </div>
            <!-- 隐藏字段，用来存储整理后的数据 -->
            <!-- <input  type="hidden" v-model="formattedMessage" name="formatted_message" /> -->
            <div class="c-mt-20 c-mb-20 c-text-left ">
              请注意，填写此信息即表示您同意我们向您发送《Franka Robotics Letters》第一期以及有关Franka Robotics的后续新闻、更新和优惠。您可以随时取消订阅我们的新闻通讯！
            </div>
            <div class="c-mt-20 c-mb-40 c-text-left ">
              如需更多信息，欢迎查看我们的隐私政策。
            </div>
            <div class="c-mt-20 c-mb-20 c-text-left ">
              Franka Robotics
              致力于保护和尊重您的隐私，我们仅会使用您的个人信息来管理您的账户，并提供您要求的产品和服务。我们可能会不时联系您，向您提供有关我们的产品和服务以及其他可能对您感兴趣的内容。如果您同意我们为此目的与您联系，请勾选以下选项，表明您希望我们通过何种方式与您联系：
            </div>
            <div class="c-text-left ">
              <label class="c-mr-20"> <input type="checkbox" v-model="isChecked1" />
              </label>
              我同意接收来自 Franka Robotics  的新闻通讯和相关信息
            </div>
            <div class="c-mt-20 c-mb-20 c-text-left ">
              为了向您提供所请求的内容，我们需要存储和处理您的个人数据。如果您同意我们存储和处理您的个人数据以供此目的使用，请勾选以下复选框。
            </div>
            <div class="c-text-left ">
              <label class="c-mr-20"> <input type="checkbox" v-model="isChecked2" />
              </label>
              我同意允许 Franka Robotics  存储和处理我的个人数据。
            </div>
            <div class="c-mt-20 c-mb-40 c-text-left ">
              您可以随时取消订阅这些通信。有关如何取消订阅、我们的隐私实践以及我们如何致力于保护和尊重您的隐私的更多信息，请查看我们的隐私政策。
            </div>
            <div style="text-align: left;">
              <button type="submit"  class="submitBtn">提交</button>
            </div>
          </form>

          <!-- <form @submit.prevent="handleSubmit" action="https://formspree.io/f/xyzegjad">
             <div class="c-text-between"> 
              <div class="form-group c-mr-10 c-flex-1">
                <label for="name">名字*</label>
                <input
                  type="text"
                  id="name"
                  v-model="name"
                  :class="{'error': nameError}"
                  @blur="validatename"
                />
                <span v-if="nameError" class="error-message">{{ nameErrorMessage }}</span>
              </div>
             </div> 
            <div class="form-group">
              <label for="email">电子邮件*</label>
              <input
                type="email"
                id="email"
                v-model="email"
                :class="{'error': emailError}"
                @blur="validateEmail"
              />
              <span v-if="emailError" class="error-message">{{ emailErrorMessage }}</span>
            </div>
            <div class="form-group">
              <label for="phone">电话号码</label>
              <input
                type="Phone "
                id="phone"
                v-model="phone" 
              /> 
            </div>
            <div class="form-group">
              <label for="job">院系名称</label>
              <input
                type="text"
                id="job"
                v-model="job"  
              /> 
            </div>
            <div class="form-group">
              <label for="company">公司名称*</label>
              <input
                type="text"
                id="company"
                v-model="company"
                :class="{'error': companyError}"
                @blur="validateCompany"
              />
              <span v-if="companyError" class="error-message">{{ companyErrorMessage }}</span>
            </div>
            <div class="form-group">
              <label for="country">国家*</label>
              <input
                type="text"
                id="country"
                v-model="country"
                :class="{'error': countryError}"
                @blur="validateCountry"
              />
              <span v-if="countryError" class="error-message">{{ countryErrorMessage }}</span>
            </div>
            <div class="form-group">
              <label for="message">消息</label> 
              <textarea class="textareaInput"
                id="message"
                v-model="message"
                rows="4"   
                cols="50"   
              ></textarea>
            </div>  
          </form> -->
        </div>
       
        <!-- <div class="  c-mb-20 c-text-left ">
          <button type="submit" class="submitBtn">提交</button>
        </div> -->

      </div>

    </div>
  </div>
</template>

<script>

export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
  name: 'App',
  components: {
    // HelloWorld
  },
  data() {
    return {
      name: '',
      email: '',                 // 存储邮箱的值
      phone: '',
      job: '',
      company: '',
      country: '',
      message: '',



      isChecked1: false,
      isChecked2: false,
      // 名字相关的验证状态和信息
      nameError: false,
      nameErrorMessage: '',
      // 姓相关的验证状态和信息

      // 邮箱相关的验证状态和信息
      emailError: false,
      emailErrorMessage: '',
      // 公司名称相关的验证状态和信息
      companyError: false,
      companyErrorMessage: '',
      // 国家相关的验证状态和信息
      countryError: false,
      countryErrorMessage: '',


      formattedMessage: ''



    }
  },
  methods: {
    // 验证名字
    validatename() {
      if (!this.name) {
        this.nameError = true;
        this.nameErrorMessage = '名字不能为空';
      } else {
        this.nameError = false;
        this.nameErrorMessage = '';
      }
    },
    // 验证邮箱
    validateEmail() {
      const emailPattern = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
      if (!this.email) {
        this.emailError = true;
        this.emailErrorMessage = '邮箱不能为空';
      } else if (!emailPattern.test(this.email)) {
        this.emailError = true;
        this.emailErrorMessage = '请输入有效的邮箱地址';
      } else {
        this.emailError = false;
        this.emailErrorMessage = '';
      }
    },
    // 公司名称
    validateCompany() {
      if (!this.company) {
        this.companyError = true;
        this.companyErrorMessage = '公司名称不能为空';
      } else {
        this.companyError = false;
        this.companyErrorMessage = '';
      }
    },
    // 国家名称
    validateCountry() {
      if (!this.country) {
        this.countryError = true;
        this.countryErrorMessage = '国家不能为空';
      } else {
        this.countryError = false;
        this.countryErrorMessage = '';
      }
    },


    submitForm() {
      // 格式化数据
      // this.formattedMessage = `
      //   姓名: ${this.name}  
      //   电子邮件: ${this.email}
      //   公司: ${this.company}
      // `; 
      this.$nextTick(() => {
        // 触发表单提交
        this.$refs.form.submit();
      });
    },
  // async createProduct( ) {
    //   let params={
    //       company: this.company,
    //       email: this.email, 
    //       job: this.job,
    //       require_info:this.message,
    //       user_name: this.name,
    //       user_phone: this.phone,
    //   }
    //   const { data, error } = await supabase.from("potential_users_info").insert([params]).select().single();
    //   if (error) {
    //     throw new Error(error.message);
    //   } 
    //   return data;
    // }, 
    // 提交表单时的处理函数
    handleSubmit() {
      this.validateEmail();
      this.validatePassword();

      // if (!this.usernameError && !this.emailError && !this.passwordError) {
      //   alert('表单已提交');
      //   // 在这里处理表单提交的逻辑
      // }
    },
  }
}
</script>

<style scoped>
.submitBtn {
  background-color: rgba(11, 123, 179, 1.0);
  border: 1px solid #0b7bb3;
  border-radius: 5px;
  color: #FFFFFF;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 18px;
}
.disSubmitBtn{
  background-color: rgb(103 114 119);
  border: 1px solid #858c8f;
  border-radius: 5px;
  color: #FFFFFF;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 18px;
}
.contact-width {
  width: calc(50% - 20px);
}

@media (max-width: 1029px) {
  .contact-width {
    width: calc(100%);
  }
}
</style>
<style scoped>
label {
  float: left;
  margin-bottom: 5px;
}

.form-container {
  width: 100%;
  margin: 0 auto;
}

.form-group {
  margin-bottom: 20px;
}

.textareaInput {

  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  border-radius: 5px;
}

input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  border-radius: 5px;
}

input.error {
  border-color: red;
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}
</style>